import { render } from "./CreateRole.vue?vue&type=template&id=21a2f3f4&scoped=true"
import script from "./CreateRole.vue?vue&type=script&lang=js"
export * from "./CreateRole.vue?vue&type=script&lang=js"

import "./CreateRole.vue?vue&type=style&index=0&id=21a2f3f4&scoped=true&lang=less"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a2f3f4"]])

export default __exports__